export { default } from './dist/vue-blockui.common'
export * from './dist/vue-blockui.common'
import './dist/vue-blockui.css'



//////////////////
// WEBPACK FOOTER
// ./~/vue-blockui/index.js
// module id = 318
// module chunks = 30